import { render } from "./istio.vue?vue&type=template&id=0a9f5d6a"
import script from "./istio.vue?vue&type=script&lang=js"
export * from "./istio.vue?vue&type=script&lang=js"

import "./istio.vue?vue&type=style&index=0&id=0a9f5d6a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__